import React from 'react';
import { string, shape, arrayOf } from 'prop-types';
var ApssFlyerBanner = function ApssFlyerBanner(_ref) {
  var _structure$cookies;
  var staticProps = _ref["static"],
    structure = _ref.structure;
  var bannerKey = staticProps.bannerKey,
    _staticProps$noBanner = staticProps.noBannerPartnerIds,
    noBannerPartnerIds = _staticProps$noBanner === void 0 ? [] : _staticProps$noBanner;
  var partnerId = structure == null ? void 0 : (_structure$cookies = structure.cookies) == null ? void 0 : _structure$cookies.partnerId;
  var showBanner = partnerId && noBannerPartnerIds.includes(partnerId) ? '' : "AF('banners', 'showBanner')";
  var content = "\n    !function(t,e,n,s,a,c,i,o,p){t.AppsFlyerSdkObject=a,t.AF=t.AF||function(){(t.AF.q=t.AF.q||[]).push([Date.now()].concat(Array.prototype.slice.call(arguments)))},t.AF.id=t.AF.id||i,t.AF.plugins={},o=e.createElement(n),p=e.getElementsByTagName(n)[0],o.async=1,o.src=\"https://websdk.appsflyer.com?\"+(c.length>0?\"st=\"+c.split(\",\").sort().join(\",\")+\"&\":\"\")+(i.length>0?\"af_id=\"+i:\"\"),p.parentNode.insertBefore(o,p)}(window,document,\"script\",0,\"AF\",\"banners\",{banners: {key: \"".concat(bannerKey, "\"}});\n    ").concat(showBanner, "\n  ");
  return React.createElement("script", {
    dangerouslySetInnerHTML: {
      __html: content
    }
  });
};
ApssFlyerBanner.ssr = true;
process.env.NODE_ENV !== "production" ? ApssFlyerBanner.propTypes = {
  "static": shape({
    bannerKey: string.isRequired,
    noBannerPartnerIds: arrayOf(string)
  }).isRequired,
  structure: shape({
    cookies: shape({
      partnerId: string
    }).isRequired
  }).isRequired
} : void 0;
export default ApssFlyerBanner;